import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./Faq.module.css";
import { db } from "../../../firebase-config";
import { collection, getDocs, query, orderBy } from "firebase/firestore";



const Faq = () => {
  const [selected, setSelected] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);



  // Fetch FAQ data from Firestore
  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        setLoading(true);
        console.log('Fetching FAQ data from Firebase...');
        
        const faqCollection = collection(db, 'faq');
        const q = query(faqCollection, orderBy('order', 'asc'));
        const querySnapshot = await getDocs(q);
        
        const firebaseFaqs = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        console.log('Firebase FAQ data:', firebaseFaqs);
        setFaqData(firebaseFaqs);
        
        console.log(`Total FAQs: ${firebaseFaqs.length} from CMS`);
        
      } catch (error) {
        console.error('Error fetching FAQ data:', error);
        // Set empty array if Firebase fails
        setFaqData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqData();
  }, []);

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };

  if (loading) {
    return (
      <div className={styles.faq}>
        <div className={styles.faqParagraph}>
          Satisfying your curiosity with clear answers.
        </div>
        <div className={styles.faqContainer}>
          <div className={styles.loading}>Loading FAQs...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.faq}>
      <div className={styles.faqParagraph}>
        Satisfying your curiosity with clear answers.
      </div>
      <div className={styles.faqContainer}>
        {faqData.map((item, i) => (
          <div
            key={item.id}
            className={styles.faqItem}
          >
            <motion.div
              className={`${styles.faqQuestion} ${selected === i ? styles.highlight : ""}`}
              onClick={() => toggle(i)}
              whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
            >
              {item.question}
              <span className={styles.faqQuestionIcons}>
                {selected === i ? "-" : "+"}
              </span>
            </motion.div>

            <div
              className={`${styles.faqAnswer} ${selected === i ? styles.show : ""}`}
            >
              <div 
                className={styles.answerContent}
                dangerouslySetInnerHTML={{ __html: item.answer || 'No answer available' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
